// Main-thread handle to the export worker (§7: one by default).
import * as Comlink from 'comlink';
import { guard } from './workerGuard';
import type { ExportWorkerApi } from './export.worker';
import type { ExportOptions } from '../engine/exportRenderer';
import type { MetadataSettings } from './encode/xmp';
import type { Settings } from '../model/types';
import type { CubeLut } from '../features/lut/cube';

let worker: Worker | null = null;
let api: Comlink.Remote<ExportWorkerApi> | null = null;

function get() {
  if (!api) {
    worker = new Worker(new URL('./export.worker.ts', import.meta.url), { type: 'module', name: 'export' });
    api = guard(worker, Comlink.wrap<ExportWorkerApi>(worker), terminateExportWorker);
  }
  return api;
}

export type MatteData = { width: number; height: number; data: Uint8Array };

/** `matte`: the photo's base background matte when the background is removed (§11.12). */
export function exportPhoto(
  file: Blob,
  settings: Settings,
  opts: ExportOptions,
  meta: MetadataSettings,
  matte?: MatteData | null,
  lut?: CubeLut | null,
  /** M22: object-pick mattes by mask id. */
  objects: (MatteData & { id: string; key: string })[] = [],
) {
  return get().exportPhoto(file, settings, opts, meta, matte ?? null, lut ?? null, objects);
}

export function terminateExportWorker() {
  worker?.terminate();
  worker = null;
  api = null;
}
